import * as z from "zod";
import { draftResultSchema } from "./common";

/**
 * A new draft automation. With a trigger it starts from that trigger's
 * defaults; without one, the editor starts by choosing it.
 */
export const createAutomation = {
  name: "createAutomation" as const,
  input: z.object({
    triggerKind: z.string().optional(),
    name: z.string().optional(),
  }),
  output: draftResultSchema,
};
